import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { getDeleteLangKey } from 'asset-actions-lib-forms/utils/getLangKey';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FormDeleteLoadingModal({
  modalProps,
  handleClose,
  formType
}) {
  return /*#__PURE__*/_jsxs(Modal, Object.assign({
    onEsc: handleClose
  }, modalProps, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleClose
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getDeleteLangKey(formType, 'cosAlert.dialogHeader')
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLib.modals.shared.okayButton"
        })
      })
    })]
  }));
}